import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from './Icon';
import { IS_APP_CODEAC } from '../constants/env';
export const DrawerItem = ({ exact = false, iconName, linkText, linkTo }) => {
    return (_jsx("li", { className: "repository-detail__menu-item", children: _jsxs(NavLink, { exact: exact, to: linkTo, activeClassName: 'repository-detail__menu-item-link--active', className: 'repository-detail__menu-item-link', children: [_jsx(Icon, { name: iconName, fixedWidth: true, ...(!IS_APP_CODEAC ? { className: 'mr-md-2' } : {}) }), _jsx("span", { children: linkText })] }) }));
};
